export const TSV_ACCOUNT_STATUSES = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
  NOT_BOUND: 'not_bound',
};

export type TsvAccountStatus = typeof TSV_ACCOUNT_STATUSES[keyof typeof TSV_ACCOUNT_STATUSES];
